// https://material.angular.io/components/table/overview
import { Component, ViewChild, ElementRef } from '@angular/core';
import { MatPaginator, MatDialog, MatSort } from '@angular/material';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../services/general.service';
import { DataService } from '../../utils/data.service';
import { modalComponent } from '../../utils/modal/modal.component';
import { NotaCreditoEliminarComponent } from './nota-credito-eliminar.component';
import { DataSourceGrid } from '../../utils/data-source-grid.component';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { DomSanitizer } from '@angular/platform-browser';
import { PersonalPDF, Personal } from '../../models/personal';
import * as moment from 'moment';
import { FormControl, Validators } from '@angular/forms';
import { NotaCreditoDetalleComponent } from '../agregar-editar/nota-credito-detalle.component';
import { Cliente } from '../../models/cliente';
import { SelectionModel } from '@angular/cdk/collections';
import { ExcelServiceHeader } from '../../utils/excel.service';
import { FacturaRegimenFiscal } from '../../models/facturaRegimenFiscal';
import { FacturaFormaPago } from '../../models/FacturaFormaPago';
import { FacturaMetodoPago } from '../../models/FacturaMetodoPago';
import { FacturaUsoCFDI } from '../../models/FacturaUsoCFDI';
import { FacturaItem } from '../../models/facturaItem';
import { FacturaItemSAT } from '../../models/facturaItemSAT';
import { FacturaUnidadMedida } from '../../models/facturaUnidadMedida';
import { Organizacion } from '../../models/organizacion';
import { Usuario } from '../../models/usuario';
import { NotaCreditoDescargarComponent } from './nota-credito-descargar.component';
import { DatosGeneralesSAE } from '../../datos-generales-SAE';
import { NotaCreditoModel, NotaCreditoDetail } from '../../models/nota-credito';
import { MatSelect } from '@angular/material/select';
import { DatePipe } from '@angular/common'
/**
 * @title Table with pagination
 */
@Component({
  selector: 'my-nota-credito-consultar',
  styleUrls: ['nota-credito-consultar.component.scss'],
  templateUrl: 'nota-credito-consultar.component.html',
  providers: [generalService, ExcelServiceHeader]
})
export class NotaCreditoConsultarComponent {

  public viewDataCliente: any[];
  private itemsShow = 10;
  private filteredItemsShowCliente = 10;
  private arrayFilteredCliente = undefined;
  private isFilteredCliente = false;
  @ViewChild('infiniteSelect') selectElem: MatSelect;

  public datosGeneralesSAE: any;
  dataSource: DataSourceGrid | null;
  displayedColumns = ['acciones', 'CUSTOMER_NAME', 'DESCRIPTION_STATUS',  'CREDIT_NOTE_NUMBER', 'SUBTOTAL_BEFORE_TAX', 'TOTAL_IVA', 'TOTAL', 'CREATION_DATE'];
  dataSource2: DataSourceGrid | null;
  displayedColumns2 = ['check', 'numeroVenta', 'nombreCliente', 'nombrePersonal', 'fechaVenta', 'status', 'nombreCreador', 'fechaCreacion'];

  public listaNotaCredito: NotaCreditoModel[] = [];
  public listaVentas: any[] = [];
  tipoFecha = 0;
  tipoDocumento = 0;
  tipoFactura = 2;
  public cantidad = 0;
  public irVentas = false;
  public userData: any = JSON.parse(sessionStorage.getItem('user'));
  public BILL_TAX_REGIME_ID: number;

  public listaCliente: Cliente[] = [];

  public notaCredito: NotaCreditoModel = null;
  listaNotaCreditoDetalle: NotaCreditoDetail[] = [];

  public fechasForm = new FormControl(null, [Validators.required]);
  public clienteForm = new FormControl(null, [Validators.required]);
  public folioForm = new FormControl('', [Validators.maxLength(20)]);

  public btnSubmit = false;

  public lstTipoVenta: any[];
   // Configuracion del daterangepicker
   locale: {
    format: 'DD/MM/YYYY',
    separator: ' - ',
    cancelLabel: 'Cancelar',
    applyLabel: 'Aceptar',
    firstDay: 1 // first day is monday
  };
  date = new Date();
  maxDate = moment().add(365, 'days');
  ranges: any = {
    'Hoy': [moment(), moment()],
    /* 'Semana actual': [moment().startOf('week'), moment().endOf('week')], */
    'Mes actual': [moment().startOf('month'), moment().endOf('month')],
    /* 'Mes pasado': [moment().subtract(1, 'month').startOf('month'), moment(), moment()], */
    'Ultimos 2 meses': [moment().subtract(2, 'month').startOf('month'), moment(), moment()],
    /* 'Ultimos 3 meses': [moment().subtract(3, 'month').startOf('month'), moment(), moment()] */
  };
  dateRange: any = {
    startDate: moment().startOf('month'),
    endDate: moment()
  };

  public seleccionado: any;
  selectionMultiple = new SelectionModel<any>(true, []);

  public idDocuments: string = '';

  nombreCliente: string = null;
  rfcCliente: string = null;
  idSucursal: number = null;

  listaRegimenFiscal: FacturaRegimenFiscal[] = [];
  listaFormaPago: FacturaFormaPago[] = [];
  listaMetodoPago: FacturaMetodoPago[] = [];
  listaCFDI: FacturaUsoCFDI[] = [];
  listaSATCode: any[] = [];
  listaCargo: any[] = [];

  listaProducto: FacturaItem[] = [];
  listaItemSAT: FacturaItemSAT[] = [];
  listaUnidad: FacturaUnidadMedida[] = [];
  listaSucursal: Organizacion[] = [];
  listaTipoRelacion: any[] = [];

  public PDF = null;
  public XML = null;
  public FILENAME_XML = '';
  public FILENAME_PDF = '';

  constructor(private _generalService: generalService, public dataService: DataService, public dialog: MatDialog, private sanitizer: DomSanitizer, public excelHeader: ExcelServiceHeader,
    public datePipe: DatePipe) {
    this.datosGeneralesSAE = DatosGeneralesSAE;
  }

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator) paginator2: MatPaginator;

  consultarNotasCredito() {
    this.datosGeneralesSAE.showSpinnerLoading = true;
    if (this.dateRange.startDate !== null && this.dateRange.endDate !== null /*&& this.clienteForm.value !== null*/) {

      const factura: any = {};

      factura.loacs = sessionStorage.getItem('acslo');
      factura.fechaInicio = this.dateRange.startDate.format('YYYY-MM-DD 00:00:00');
      factura.fechaFin = this.dateRange.endDate.format('YYYY-MM-DD 23:59:59');
      factura.idCliente = this.clienteForm.value;
      factura.folio = (this.folioForm.value === null) ? '' : this.folioForm.value;
      this._generalService.metodoCallParams(factura, 'NotaCredito/consultNotasCredito').subscribe(
          (result) => {
            this.listaNotaCredito = JSON.parse(result);
            this.dataSource = new DataSourceGrid(this.listaNotaCredito, this.paginator, this.sort);
            this.cantidad = this.listaNotaCredito.length;
            if (this.listaNotaCredito.length <= 0) {
              $('.mat-row').remove('.mat-row');
              this._generalService.toastCall('No se encontraron registros');
            }
            this.datosGeneralesSAE.showSpinnerLoading = false;
            },
          (error) => {
            this.datosGeneralesSAE.showSpinnerLoading = false;
          }
        );
    } else {
      this.datosGeneralesSAE.showSpinnerLoading = false;
      this._generalService.toastCall('Las fechas son requeridas');
    }
  }

  consultarEstatusActual() {
    if (this.dateRange.startDate !== null && this.dateRange.endDate !== null /*&& this.clienteForm.value !== null*/) {
      const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
      const idOrganizacion = usuarioSession.ORGANIZATION_ID;
      const idCompania = this.listaSucursal.find((row) => row.ORGANIZATION_ID === +idOrganizacion).COMPANY_ID;
      const factura: any = {};
      
      factura.ORGANIZATION_ID = idOrganizacion;
      factura.idCompania = idCompania;

      factura.loacs = sessionStorage.getItem('acslo');
      factura.fechaInicio = this.dateRange.startDate.format('YYYY-MM-DD 00:00:00');
      factura.fechaFin = this.dateRange.endDate.format('YYYY-MM-DD 23:59:59');
      factura.idCliente = this.clienteForm.value;
      factura.folio = (this.folioForm.value === null) ? '' : this.folioForm.value;
      this._generalService.metodoCallParams(factura, 'NotaCredito/actualizarStatus').subscribe(
          (result) => {
            this._generalService.toastCall('Se actualizó el estatus a las facturas exitosamente!');
            this.consultarNotasCredito();
          },
          (error) => {
            
          }
        );
    } else {
      this._generalService.toastCall('Las fechas son requeridas');
    }
  }

  regresarNotasCredito() {
    this.irVentas = false;
    this.listaVentas = [];
    this.tipoDocumento = 0;
    this.tipoFecha = 0;
    this.dateRange = {
      startDate: moment().startOf('month'),
      endDate: moment()
    };
    this.tipoFactura = 2;

  }

  changeCliente() {
    if (this.clienteForm.value !== null) {
      const cliente = this.listaCliente.find((element) => element.idCliente === this.clienteForm.value);
      this.rfcCliente = cliente.rfc;
      this.nombreCliente = cliente.razonSocial;
    } else {
      this.rfcCliente = null;
      this.nombreCliente = null;
    }
  }

  editar(idNotaCredito: number) {
    this.dataService.id = idNotaCredito;
    this.dataService.tipo = 'editar';
    this.idDocuments = null;
    this.dataService.factura = {
      idDocuments: this.idDocuments,
      tipoFactura: this.tipoFactura,
      idCliente: this.clienteForm.value,
      CUSTOMER_NAME: this.nombreCliente,
      CUSTOMER_RFC: this.rfcCliente
    };
    const dialogRef = this.dialog.open(NotaCreditoDetalleComponent, {disableClose: true, width: '95vw', height: '90vh', maxWidth: '95vw', maxHeight: '95vh', panelClass: 'full-width-dialog'});
    this.dataService.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe((result) => {
      if (this.dataService.guardado) {
        this._generalService.toastCall('El registro se modificó exitosamente!');
        this.consultarNotasCredito();
        this.regresarNotasCredito();
      }
    });
  }

  agregar() {
    if (this.clienteForm.value !== null && this.clienteForm.value !== undefined) {
      this.dataService.id = null;
      this.dataService.tipo = 'agregar';
      this.idDocuments = '';
      if (this.selectionMultiple.selected.length > 0 ) {
        this.selectionMultiple.selected.forEach((element) => {
          this.idDocuments += element.DOCUMENT_ID + ',';
        });
        this.idDocuments = this.idDocuments.slice(0, -1);
      }

      //Se prepara para enviar el BILL_TAX_REGIME_ID al modal
      for(let i = 0; i < this.listaCliente.length; i ++){
        if(this.listaCliente[i].idCliente == this.clienteForm.value){
          this.BILL_TAX_REGIME_ID = this.listaCliente[i].BILL_TAX_REGIME_ID;
          break;
        }
      }

      this.dataService.factura = {
        idDocuments: this.idDocuments,
        tipoFactura: this.tipoFactura,
        idCliente: this.clienteForm.value,
        CUSTOMER_NAME: this.nombreCliente,
        CUSTOMER_RFC: this.rfcCliente,
        BILL_TAX_REGIME_ID: this.BILL_TAX_REGIME_ID
      };
    // this.dataService.idDocuments = this.idDocuments;
    // this.dataService.tipoFactura = this.tipoFactura;
      const dialogRef = this.dialog.open(NotaCreditoDetalleComponent, {
        disableClose: true, width: '95vw', height: '70vh', maxWidth: '95vw', maxHeight: '95vh', panelClass: 'full-width-dialog'
      });
      this.dataService.dialogRef = dialogRef;
      dialogRef.afterClosed().subscribe((result) => {
        if (this.dataService.guardado) {
          this._generalService.toastCall('El registro se agregó exitosamente!');
          this.consultarNotasCredito();
          this.regresarNotasCredito();
        }
      });
    } else {
      this._generalService.toastCall('El cliente es requerido!');
      this.clienteForm.markAsTouched();
    }
  }

  consultarClientes() {
    const factura: any = {};
    factura.loacs = sessionStorage.getItem('acslo');

    this._generalService.metodoCallParams(factura, 'cliente/consultarClientes').subscribe(
        (result) => {
          if ( JSON.parse(result) !== null &&  JSON.parse(result) !== undefined) {
            this.listaCliente = JSON.parse(result);
            this.viewDataCliente = this.listaCliente.slice(0, 10);
          } else {
            this.listaCliente = [];
          }
          },
        (error) => {
         
        }
      );
  }

  ngOnInit() {
    this.consultarClientes();
    this.consultarCFDI();
    this.consultarFormaPago();
    this.consultarMetodoPago();
    this.consultarRegimenFiscales();
    this.consultarSucursales();
    this.consultarUnidades();
    this.consultSATcode();
    this.consultarTipoRelacion();

    this.consultarNotasCredito();

    /***************************INFINITE SELECT**********************************/    
     setTimeout(() => 
                this.selectElem.onOpen.subscribe(() => this.registerPanelScrollEvent()),
            2);
    /***************************INFINITE SELECT**********************************/
  }

  eliminarConfirm(data: any) {
    console.warn(data);
    if (!this.btnSubmit) {
      this.btnSubmit = true;
      this.dataService.id = data.BILL_CREDIT_NOTE_ID;

      const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
      const idOrganizacion = usuarioSession.ORGANIZATION_ID;
      const idCompania = this.listaSucursal.find((row) => row.ORGANIZATION_ID === +idOrganizacion).COMPANY_ID;
      this.dataService.factura = {idOrganizacion, idCompania, uuid: data.UUID,
        TOTAL: data.TOTAL, 
        MOTIVO: "02", 
      CUSTOMER_ID: this.clienteForm.value,
        //CUSTOMER_ID:data.CUSTOMER_ID,
        CREDIT_NOTE_NUMBER: data.CREDIT_NOTE_NUMBER};

      const dialogRef = this.dialog.open(NotaCreditoEliminarComponent, {disableClose: true});
      this.dataService.dialogRef =
       dialogRef;
      dialogRef.afterClosed().subscribe((result) => {
          this.consultarNotasCredito();
          this.btnSubmit = false;
        });
    } else {
      this.btnSubmit = false;
    }
  }

  public ExportarExcel() {
      const hoy = new Date();
      const fecha = hoy.getDate() + '/' + ( hoy.getMonth() + 1 ) + '/' + hoy.getFullYear();
      const hora = hoy.getHours() + ':' + hoy.getMinutes() + ':' + hoy.getSeconds();
      const fechayHora = fecha + ' ' + hora;

      const datosHeader = {
        cliente: this.nombreCliente,
        rfc: this.rfcCliente,
        segundoTextoHeader: 'MRSAE',
        tercerTextoHeader: 'Resumen de Notas de credito',
        fechaHoraImpresion: fechayHora,
        numeroPagina: 'Página 1 de 1'
      };

      if ( this.listaNotaCredito.length > 0) {

        for(let i = 0; i < this.listaNotaCredito.length; i++){
          this.listaNotaCredito[i].FECHA = this.datePipe.transform(this.listaNotaCredito[i].CREATION_DATE, 'dd/MM/yyyy');
        }

        const filename = 'resumen-notas-credito' ;

        const columns = [{display: 'Cliente', name: 'CUSTOMER_NAME', tipoDato: 'string'},
                      {display: 'Estatus', name: 'DESCRIPTION_STATUS', tipoDato: 'string'},
                      {display: 'Numero De Folio', name: 'CREDIT_NOTE_NUMBER', tipoDato: 'string'},
                      {display: 'Subtotal', name: 'SUBTOTAL_BEFORE_TAX', tipoDato: 'string'},
                      {display: 'IVA', name: 'TOTAL_IVA', tipoDato: 'string'},
                      {display: 'Total', name: 'TOTAL', tipoDato: 'string'},
                      {display: 'Fecha', name: 'FECHA', tipoDato: 'string'},
                      ];

        this.excelHeader.exportXlsTableView( this.listaNotaCredito, columns, filename, datosHeader);
      }
  }

  timbrarNotaCredito(id: any, idCompania: any) {
    if (!this.btnSubmit) {
      this.btnSubmit = true;
      this.datosGeneralesSAE.showSpinnerLoading = true;
      this.notaCredito = new NotaCreditoModel();
      this.notaCredito.BILL_CREDIT_NOTE_ID = id;
      this._generalService.metodoCallParams(this.notaCredito, `NotaCredito/consultBillCreditNote/`).subscribe(
          (result) => {
              const res = JSON.parse(result);
              if (res.Table.length > 0) {
                  this.notaCredito = res.Table[0];
                  this.notaCredito.NotaCreditoDocumentos = res.Table1;
                  this._generalService.metodoCallParams(this.notaCredito, `NotaCredito/consultBillCreditNoteDetailt/`).subscribe(
                      (result2) => {
                          const res2 = JSON.parse(result2);
                   
                          this.listaNotaCreditoDetalle = res2;
                          this.enviar(idCompania);
                      },
                      (error) => {
                        this.btnSubmit = false;
                        this.datosGeneralesSAE.showSpinnerLoading = false;
                      
                      }
                  );

              } else {
                this.btnSubmit = false;
                this.datosGeneralesSAE.showSpinnerLoading = false;
              }
          },
          (error) => {
            this.btnSubmit = false;
            this.datosGeneralesSAE.showSpinnerLoading = false;
           
          }
      );
    }
  }

  download(id: any, idCompania: any) {
    if (!this.btnSubmit) {
      this.btnSubmit = true;
      this.datosGeneralesSAE.showSpinnerLoading = true;
      this.notaCredito = new NotaCreditoModel();
      this.notaCredito.BILL_CREDIT_NOTE_ID = id;
      this._generalService.metodoCallParams(this.notaCredito, `NotaCredito/consultBillCreditNote/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res.Table.length > 0) {
                    this.notaCredito = res.Table[0];
                    this.notaCredito.NotaCreditoDocumentos = res.Table1;
                    this._generalService.metodoCallParams(this.notaCredito, `NotaCredito/consultBillCreditNoteDetailt/`).subscribe(
                        (result2) => {
                            const res2 = JSON.parse(result2);
                          
                            this.listaNotaCreditoDetalle = res2;
                            this.recuperarArchivos(idCompania);
                        },
                        (error) => {
                          this.btnSubmit = false;
                          this.datosGeneralesSAE.showSpinnerLoading = false;
                      
                        }
                    );

                } else {
                  this.btnSubmit = false;
                  this.datosGeneralesSAE.showSpinnerLoading = false;
                }
            },
            (error) => {
              this.btnSubmit = false;
              this.datosGeneralesSAE.showSpinnerLoading = false;
      
            }
        );
        }
  }

  enviar(idCliente: any) {
      const params = this.generarComprobante(idCliente);
      console.warn(params);
      
      this._generalService.requestPostParams(params, 'NotaCredito/timbrar/').subscribe(
      (result) => {
        this.datosGeneralesSAE.showSpinnerLoading = false;
        const archivo = JSON.parse(result);
        this.PDF = archivo.PDF;
        this.XML = archivo.XML;
        this.FILENAME_XML = archivo.FILENAME_XML;
        this.FILENAME_PDF = archivo.FILENAME_PDF;

        const dialogRef = this.dialog.open(NotaCreditoDescargarComponent,  {disableClose: true}
          );

        dialogRef.afterClosed().subscribe((res) => {
          if (res) {
            // this.descargarArchivos();
            this.btnSubmit = false;
            this.download(params.notaCredito.BILL_CREDIT_NOTE_ID, idCliente)
          }
          this.btnSubmit = false;
          this.consultarNotasCredito();
        });

      },
      (error) => {
        this.btnSubmit = false;
        this.datosGeneralesSAE.showSpinnerLoading = false;
        this._generalService.handleError(error);
      
      }
    );
    
  }

  recuperarArchivos(idCliente: any) {
      const params = this.generarComprobante(idCliente);
      this._generalService.requestPostParams(params, 'notaCredito/descargarArchivosNotaCredito/').subscribe(
        (result) => {
          this.btnSubmit = false;
          this.datosGeneralesSAE.showSpinnerLoading = false;
          const archivo = JSON.parse(result);
          this.PDF = archivo.PDF;
          this.XML = archivo.XML;
          this.FILENAME_XML = archivo.FILENAME_XML;
          this.FILENAME_PDF = archivo.FILENAME_PDF;
          this.descargarArchivos();
          this.consultarNotasCredito();
        },
        (error) => {
          this.datosGeneralesSAE.showSpinnerLoading = false;
          this._generalService.handleError(error);
          this.btnSubmit = false;
        }
      );
  }

  generarComprobante(idCliente: any) {
    const conceptos: any = [];
    let tieneImpuestos = false;
    const unidadSAT = this.listaRegimenFiscal.find((ele) => ele.BILL_TAX_REGIME_ID === this.notaCredito.TAX_REGIME_ID);
    this.listaNotaCreditoDetalle.forEach((notaCreditoDetalle) => {
        const unidad = this.listaUnidad.find((ele) => ele.BILL_UNIT_MEASURE_ID === notaCreditoDetalle.UNIT_MEASURE_ID);
        const sat =  this.listaSATCode.find((p) => p.itemSATcodeId === notaCreditoDetalle.ITEM_SAT_ID);
        conceptos.push({
          Importe: notaCreditoDetalle.AMOUNT,
          ClaveProdServ: '84111506', // Fijo
          cantidad: 1, // Fijo
          ClaveUnidad: 'ACT', // Fijo
          Descripcion: notaCreditoDetalle.DESCRIPTION,
          ValorUnitario: Math.round(((notaCreditoDetalle.AMOUNT / notaCreditoDetalle.QUANTITY) + Number.EPSILON) * 100) / 100,
          Unidad: 'Unidades de venta', // Fijo
          objetoImp: "02",

          /*
          Importe: notaCreditoDetalle.AMOUNT,
          ClaveProdServ: sat.SATcode,
          cantidad: notaCreditoDetalle.QUANTITY,
          ClaveUnidad: unidad.BILL_UNIT_MEASURE_KEY,
          Descripcion: notaCreditoDetalle.DESCRIPTION,
          ValorUnitario: Math.round(((notaCreditoDetalle.AMOUNT / notaCreditoDetalle.QUANTITY) + Number.EPSILON) * 100) / 100,
          Unidad: unidad.NAME
          */
          /*Impuestos: {
            Traslados: []
          }*/
        });
        if (notaCreditoDetalle.IVA_FACTOR > 0) {
          conceptos[conceptos.length - 1].Impuestos = {};
          conceptos[conceptos.length - 1].Impuestos.Traslados = new Array();
          tieneImpuestos = true;
          conceptos[conceptos.length - 1].Impuestos.Traslados.push(
            {Importe:  notaCreditoDetalle.IVA_AMOUNT.toFixed(2), importeFieldSpecified: true, TasaOCuota:  notaCreditoDetalle.IVA_FACTOR.toString() + '0000', tasaOCuotaFieldSpecified: true, TipoFactor: 'Tasa', Impuesto: '002', 
            objetoImp: "02",
            Base: notaCreditoDetalle.AMOUNT, baseField: notaCreditoDetalle.AMOUNT}
          );
        } else {
         // conceptos
        }
      });

    const formaPago = this.listaFormaPago.find((ele) => ele.BILL_PAYMENT_FORM_ID === this.notaCredito.RECEIVER_PAYMENT_FORM_ID);
    const metodoPago = this.listaMetodoPago.find((ele) => ele.BILL_PAYMENT_METHOD_ID === this.notaCredito.RECEIVER_PAYMENT_METHOD_ID);

    const regimenFiscal = this.listaRegimenFiscal.find((ele) => ele.BILL_TAX_REGIME_ID === this.notaCredito.TAX_REGIME_ID);

    const usoCFDI = this.listaCFDI.find((ele) => ele.BILL_CFDI_USE_ID === this.notaCredito.RECEIVER_CFDI_USE_ID);

    const tipoRelacion = this.listaTipoRelacion.find((ele) => ele.RELATION_TYPE_SAT_ID === this.notaCredito.RELATION_TYPE_SAT_ID);    

    let cfdiRelacionados =  {
       //MH TipoRelacion: tipoRelacion.RELATION_TYPE_SAT_KEY,  MH
       TipoRelacion: tipoRelacion.RELATION_TYPE_SAT_KEY,
        CfdiRelacionado: []
    };

    for(let i = 0; i < this.notaCredito.NotaCreditoDocumentos.length; i++) {
      cfdiRelacionados.CfdiRelacionado.push({UUID: this.notaCredito.NotaCreditoDocumentos[i].UUID});
    }


    const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
    const idOrganizacion = usuarioSession.ORGANIZATION_ID;
    const idCompania = this.listaSucursal.find((row) => row.ORGANIZATION_ID === +idOrganizacion).COMPANY_ID;
    const fechaActual = new Date();
    const mes = fechaActual.getMonth() + 1;
    const hora = (fechaActual.getHours() % 12) || 12;
    const minutos = fechaActual.getMinutes();
    const segundos = fechaActual.getSeconds();
    const fechaActualString = fechaActual.getFullYear() + '-' +
      ((mes > 9) ? mes : '0' + mes)  + '-' +
      ((fechaActual.getDate() > 9) ? fechaActual.getDate() : '0' + fechaActual.getDate() )  + 'T' +
      ((hora > 9) ? hora : '0' + hora)  + ':' +
      ((minutos > 9) ? minutos : '0' + minutos) + ':' +
      ((segundos > 9) ? segundos : '0' + segundos) ;
    const comprobante: any = {
        Version: '4.0',
        Fecha: fechaActualString, // FORMATO: yyyy-MM-ddThh:mm:ss
        FormaPago: formaPago.BILL_PAYMENT_FORM_KEY,
        SubTotal: this.notaCredito.SUBTOTAL_BEFORE_TAX,
        Moneda: (this.notaCredito.CURRENCY !== null) ? this.notaCredito.CURRENCY : 'MXN',
        Total: this.notaCredito.TOTAL,
        TipoDeComprobante: 'E', // Fijo
        Folio: this.notaCredito.CREDIT_NOTE_NUMBER.replace("NC", ""),
        Serie: 'NC',
        MetodoPago: metodoPago.BILL_PAYMENT_METHOD_KEY,
        LugarExpedicion: '',
        Emisor: {
        // Nombre: 'Osmar Roque',
        // Rfc: 'AAA010101AAA',
          RegimenFiscal: regimenFiscal.BILL_TAX_REGIME_KEY
        },
        Receptor: {
        // Nombre: 'Mauricio Paredes',
        // Rfc: 'LAN8507268IA',
          UsoCFDI: usoCFDI.BILL_CFDI_USE_KEY
        },
        Conceptos: conceptos,
        CfdiRelacionados: cfdiRelacionados,
        Impuestos: {

        }
      };
    if (tieneImpuestos) {
      console.warn(this.notaCredito);
            comprobante.Impuestos =  {
                TotalImpuestosTrasladados: this.notaCredito.TOTAL_IVA.toFixed(2), totalImpuestosTrasladadosFieldSpecified: false,
              // TotalImpuestosRetenidos: 0.00, totalImpuestosRetenidosFieldSpecified: false,
              Traslados: [
                  // {Impuesto: '002', TipoFactor: 'Tasa', TasaOCuota: '0.160000', Importe: 48.00}
                ]
              };
            // Si se manejan mas tipos de impuestos, hay que insertar un traslado de cada tipo
            comprobante.Impuestos.Traslados.push({
              objetoImp: "02",

              Impuesto: '002', TipoFactor: 'Tasa', TasaOCuota: '0.160000', Importe: this.notaCredito.TOTAL_IVA.toFixed(2)
              , baseField: this.notaCredito.SUBTOTAL_BEFORE_TAX
            });
      }

    const params: any = {};
    params.comprobante = comprobante;
    params.cliente = { idCliente: this.clienteForm.value ? this.clienteForm.value : idCliente};
    params.compania = { idCompania };
    params.descripcionSAT = {
      formaPago: formaPago.BILL_PAYMENT_FORM_KEY + ' - ' + formaPago.DESCRIPTION,
      metodoPago: metodoPago.BILL_PAYMENT_METHOD_KEY + ' - ' + metodoPago.DESCRIPTION,
      regimenFiscal: regimenFiscal.BILL_TAX_REGIME_KEY + ' - ' + regimenFiscal.DESCRIPTION,
      usoCFDI: usoCFDI.BILL_CFDI_USE_KEY,
      tipoComprobante: 'E - Egreso'
    };
    params.notaCredito = { ORGANIZATION_ID: idOrganizacion, BILL_CREDIT_NOTE_ID: this.notaCredito.BILL_CREDIT_NOTE_ID, loacs: sessionStorage.getItem('acslo'), NotaCreditoDocumentos: this.notaCredito.NotaCreditoDocumentos, RELATION_TYPE_SAT_ID: this.notaCredito.RELATION_TYPE_SAT_ID, CREDIT_NOTE_NUMBER: this.notaCredito.CREDIT_NOTE_NUMBER };
    return params;
  }

  prepararPDFYXMLEnvioPorCorreo(id: any, row: any){
   if (!this.btnSubmit) {
      this.btnSubmit = true;
      this.datosGeneralesSAE.showSpinnerLoading = true;
      this.notaCredito = new NotaCreditoModel();
      this.notaCredito.BILL_CREDIT_NOTE_ID = id;
      this._generalService.metodoCallParams(this.notaCredito, `NotaCredito/consultBillCreditNote/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res.Table.length > 0) {
                    this.notaCredito = res.Table[0];
                    this.notaCredito.NotaCreditoDocumentos = res.Table1;
                    this._generalService.metodoCallParams(this.notaCredito, `NotaCredito/consultBillCreditNoteDetailt/`).subscribe(
                        (result2) => {
                            const res2 = JSON.parse(result2);
                          
                            this.listaNotaCreditoDetalle = res2;
                            this.recuperarArchivosCorreo(row);
                        },
                        (error) => {
                          this.btnSubmit = false;
                          this.datosGeneralesSAE.showSpinnerLoading = false;
                      
                        }
                    );

                } else {
                  this.btnSubmit = false;
                  this.datosGeneralesSAE.showSpinnerLoading = false;
                }
            },
            (error) => {
              this.btnSubmit = false;
              this.datosGeneralesSAE.showSpinnerLoading = false;
      
            }
        );
        }
  }

  recuperarArchivosCorreo(idCliente: any){
     const params = this.generarComprobante(idCliente);
      this._generalService.requestPostParams(params, 'notaCredito/descargarArchivosNotaCredito/').subscribe(
        (result) => {
          this.btnSubmit = false;
          this.datosGeneralesSAE.showSpinnerLoading = false;
          const archivo = JSON.parse(result);
          this.PDF = archivo.PDF;
          this.XML = archivo.XML;
          this.FILENAME_XML = archivo.FILENAME_XML;
          this.FILENAME_PDF = archivo.FILENAME_PDF;
          this.enviarPorCorreo(idCliente);

        },
        (error) => {
          this.datosGeneralesSAE.showSpinnerLoading = false;
          this._generalService.handleError(error);
          this.btnSubmit = false;
        }
      );
  }

  enviarPorCorreo(idCliente: any){
    const params = this.generarComprobante(idCliente);
    this._generalService.requestPostParams(params, 'notaCredito/enviarArchivosDeNotaCreditoPorEmail/').subscribe(
      (result) => {
        this.btnSubmit = false;
        this.datosGeneralesSAE.showSpinnerLoading = false;
        const response = result;
        if(response == "ok")
        {
          this._generalService.toastCall("Envio por E-Mail Correctamente");
        }
        else
        {
          this._generalService.toastCall(response);
        }
        
      },
      (error) => {
        this.datosGeneralesSAE.showSpinnerLoading = false;
        this._generalService.handleError(error);
        this.btnSubmit = false;
      }
    );
  }
  

  descargarArchivos() {
    const blob = this.base64PDFToBlob(this.PDF);

    let link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = this.FILENAME_PDF + '.pdf';
    // some browser needs the anchor to be in the doc
    document.body.appendChild(link);
    link.click();
    link.remove();

    const bb = new Blob([this.XML], {type: 'text/plain'});

    link = document.createElement('a');
    link.href = URL.createObjectURL(bb);
    link.download = this.FILENAME_XML + '.xml';
    // some browser needs the anchor to be in the doc
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  base64PDFToBlob(base64) {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; ++i) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return new Blob([bytes], { type: 'application/pdf' });
  }

  consultarUnidades() {
    this._generalService.metodoCall(`factura/getUnidades/`).subscribe(
        (result) => {
            const res = JSON.parse(result);
            if (res !== null && res !== undefined && res.length > 0) {
                this.listaUnidad = res;
            } else {
                this.listaUnidad = [];
            }
        },
        (error) => {
            this.listaUnidad = [];
          
        }
    );
}

consultarTipoRelacion() {
  this._generalService.metodoCall(`NotaCredito/consultarTipoRelacion/`).subscribe(
      (result) => {
          const res = JSON.parse(result);
          if (res !== null && res !== undefined && res.length > 0) {
              this.listaTipoRelacion = res;
          } else {
              this.listaTipoRelacion = [];
          }
      },
      (error) => {
          this.listaTipoRelacion = [];
      
      }
  );
}

consultSATcode() {
  this._generalService.metodoCall(`itemCodeSAT/consultItemSATcodes/`).subscribe(
      (result) => {
          const res = JSON.parse(result);
          if (res !== null && res !== undefined && res.length > 0) {
              this.listaSATCode = res;
          } else {
              this.listaSATCode = [];
          }
      },
      (error) => {
          this.listaSATCode = [];
    
      }
  );
}

consultarSucursales() {
  this._generalService.metodoCall(`compania/consultarSucursales/`).subscribe(
      (result) => {
          const res = JSON.parse(result);
          if (res !== null && res !== undefined && res.length > 0) {
              this.listaSucursal = res;
          } else {
              this.listaSucursal = [];
          }
      },
      (error) => {
          this.listaSucursal = [];
        
      }
  );
}

consultarRegimenFiscales() {
  this._generalService.metodoCall(`factura/getRegimenFiscal/`).subscribe(
      (result) => {
          const res = JSON.parse(result);
          if (res !== null && res !== undefined && res.length > 0) {
              this.listaRegimenFiscal = res;
          } else {
              this.listaRegimenFiscal = [];
          }
      },
      (error) => {
          this.listaRegimenFiscal = [];
     
      }
  );
}

consultarFormaPago() {
  this._generalService.metodoCall(`factura/getFormaPago/`).subscribe(
      (result) => {
          const res = JSON.parse(result);
          if (res !== null && res !== undefined && res.length > 0) {
              this.listaFormaPago = res;
          } else {
              this.listaFormaPago = [];
          }
      },
      (error) => {
          this.listaFormaPago = [];
      
      }
  );
}

consultarMetodoPago() {
  this._generalService.metodoCall(`factura/getMetodoPago/`).subscribe(
      (result) => {
          const res = JSON.parse(result);
          if (res !== null && res !== undefined && res.length > 0) {
              this.listaMetodoPago = res;
          } else {
              this.listaMetodoPago = [];
          }
      },
      (error) => {
          this.listaMetodoPago = [];
       
      }
  );
}

consultarCFDI() {
  this._generalService.metodoCall(`factura/getCFDI/`).subscribe(
      (result) => {
          const res = JSON.parse(result);
          if (res !== null && res !== undefined && res.length > 0) {
              this.listaCFDI = res;
          } else {
              this.listaCFDI = [];
          }
      },
      (error) => {
          this.listaCFDI = [];
         
      }
  );
}

fetchMore() {
  if(this.itemsShow < this.listaCliente.length) {
    this.itemsShow += 10;
    this.viewDataCliente = this.listaCliente.slice(0, this.itemsShow);
  }  
}

onKeyUpCliente(val: any) {
    let arr: any[];
    if (val.currentTarget.value != "") {
      this.arrayFilteredCliente = this.listaCliente.filter((obj) => {
        return obj.razonSocial.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1;
      })

      arr = this.arrayFilteredCliente.slice(0, this.filteredItemsShowCliente);
      this.isFilteredCliente = true;
    } else {
      /***************************INFINITE SELECT**********************************/
      // arr = this.filtroSATCodes;
      this.isFilteredCliente = false;
      this.filteredItemsShowCliente = 10;
      this.arrayFilteredCliente = undefined;
      arr = this.listaCliente.slice(0, this.itemsShow);
      /***************************INFINITE SELECT**********************************/
    }
    /***************************INFINITE SELECT**********************************/
    this.viewDataCliente = arr;
    /***************************INFINITE SELECT**********************************/
  }

  /***************************INFINITE SELECT**********************************/
  registerPanelScrollEvent() {
    const panel = this.selectElem.panel.nativeElement;
    panel.addEventListener('scroll', event => this.loadAllOnScroll(event));
  }

  loadAllOnScroll(event) {
    if (event.target.scrollTop === (event.target.scrollHeight - event.target.offsetHeight)) {
      if(this.isFilteredCliente) {
        if(this.filteredItemsShowCliente < this.arrayFilteredCliente.length) {
            this.filteredItemsShowCliente += 10;
            this.viewDataCliente = this.arrayFilteredCliente.slice(0, this.filteredItemsShowCliente);
        }
      } else {
        if(this.itemsShow < this.listaCliente.length) {
          this.itemsShow += 10;
          this.viewDataCliente = this.listaCliente.slice(0, this.itemsShow);
        }
      }
    }
  }
  /***************************INFINITE SELECT**********************************/

}



// WEBPACK FOOTER //
// ./src/app/nota-credito/consultar-eliminar/nota-credito-consultar.component.ts